
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import principalImg from '../../assets/principal.jpeg';
import heroBg1 from '../../assets/elite pics/WhatsApp Image 2026-01-27 at 9.58.35 AM.jpeg?url';
import heroBg2 from '../../assets/Sports Images/WhatsApp Image 2026-05-20 at 8.10.21 PM (2).jpeg?url';
import heroBg3 from '../../assets/Sports Images/WhatsApp Image 2026-05-20 at 8.10.25 PM.jpeg?url';
import heroBg4 from '../../assets/Sports Images/WhatsApp Image 2026-05-20 at 8.10.27 PM.jpeg?url';

export default function About() {
  const heroBgs = [heroBg1, heroBg2, heroBg3, heroBg4];
  const [currentBg, setCurrentBg] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBg(prev => (prev + 1) % heroBgs.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative min-h-screen">
      <Navigation />

      {/* Hero Section */}
      <section className="relative py-24 pt-44 overflow-hidden">
        {/* Rotating background images */}
        {heroBgs.map((bg, i) => (
          <div
            key={i}
            className="absolute inset-0 bg-cover bg-center transition-opacity duration-1000"
            style={{ backgroundImage: `url(${bg})`, opacity: i === currentBg ? 1 : 0 }}
          />
        ))}
        {/* Overlay for text readability */}
        <div className="absolute inset-0 bg-[#2E7D32]/65 z-10" />

        <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <div className="inline-flex items-center px-6 py-3 bg-white/20 backdrop-blur-sm rounded-full border border-white/40 mb-8">
            <span className="text-[#C6A44C] text-sm font-semibold">🏛️ Our Story Since 2019</span>
          </div>
          <h1 className="text-5xl md:text-7xl font-bold mb-8 leading-tight">About Elite College</h1>
          <p className="text-xl md:text-2xl opacity-90 max-w-4xl mx-auto leading-relaxed">
            Discover our rich history, unwavering mission, and commitment to educational excellence that has shaped thousands of lives
          </p>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="space-y-8">
              <div className="space-y-6">
                <div className="inline-flex items-center px-4 py-2 bg-[#388E3C]/10 rounded-full">
                  <span className="text-[#2E7D32] text-sm font-semibold">Our Story Since 2019</span>
                </div>
                <h2 className="text-4xl md:text-5xl font-bold text-[#2E7D32]">Building Excellence Together</h2>
                <p className="text-xl text-gray-600 leading-relaxed">
                  Founded in 2019, Elite College has been dedicated to providing exceptional education that transforms lives and builds futures. Our journey began with a simple yet powerful vision: to create an institution where every student can thrive and reach their full potential.
                </p>
                <p className="text-lg text-gray-600 leading-relaxed">
                  From our humble beginnings, we have grown into a respected educational institution known for our commitment to academic excellence, character development, and community engagement. Our dedicated faculty and staff work tirelessly to ensure that each student receives the support and guidance they need to succeed.
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to="/admissions" className="group bg-[#C6A44C] hover:bg-[#B8954A] text-white px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl transform hover:-translate-y-1 text-center">
                  Join Our Community
                </Link>
                <Link to="/contact" className="group border-2 border-[#007A3D] text-[#007A3D] hover:bg-[#007A3D] hover:text-white px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-300 whitespace-nowrap cursor-pointer text-center">
                  Learn More
                </Link>
              </div>
            </div>
            <div className="relative">
              <div className="relative overflow-hidden rounded-2xl shadow-2xl">
                <img 
                  src="https://static.readdy.ai/image/e999ec2dea4e4b618de520757ef9db5d/a7c3ff689189f361137f348d1ab7570c.png" 
                  alt="Elite College Campus" 
                  className="w-full h-[500px] object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#005A2C]/20 to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-20 bg-gradient-to-br from-[#007A3D]/5 to-[#C6A44C]/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center px-4 py-2 bg-[#007A3D]/10 rounded-full mb-6">
              <span className="text-[#007A3D] text-sm font-semibold">Our Foundation</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#005A2C] mb-6">Mission & Vision</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">Guiding principles that shape our educational approach and inspire our community</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="group bg-white p-10 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-[#007A3D]/10 to-transparent rounded-full transform translate-x-16 -translate-y-16"></div>
              <div className="relative z-10">
                <div className="w-20 h-20 bg-gradient-to-br from-[#007A3D] to-[#005A2C] rounded-2xl flex items-center justify-center mx-auto mb-8 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-compass-3-line text-3xl text-white"></i>
                </div>
                <h3 className="text-3xl font-bold text-[#005A2C] mb-6 text-center">Our Mission</h3>
                <p className="text-gray-600 text-center text-lg leading-relaxed">
                  Elite College is dedicated to teaching students to develop a deep understanding and appreciation of our complex social, cultural, and physical world. We are committed to nurturing every child to realize their highest potential.
                </p>
              </div>
            </div>

            <div className="group bg-white p-10 rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-[#C6A44C]/10 to-transparent rounded-full transform translate-x-16 -translate-y-16"></div>
              <div className="relative z-10">
                <div className="w-20 h-20 bg-gradient-to-br from-[#C6A44C] to-[#B8954A] rounded-2xl flex items-center justify-center mx-auto mb-8 group-hover:scale-110 transition-transform duration-300">
                  <i className="ri-telescope-line text-3xl text-white"></i>
                </div>
                <h3 className="text-3xl font-bold text-[#005A2C] mb-6 text-center">Our Vision</h3>
                <p className="text-gray-600 text-center text-lg leading-relaxed">
                  To be a revered and efficient institution by grooming students through creative, mature knowledge sharing, dedicated teaching, and the faithful inclusion of the parental community.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-20 bg-gradient-to-br from-[#C6A44C]/5 to-[#007A3D]/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center px-4 py-2 bg-[#007A3D]/10 rounded-full mb-6">
              <span className="text-[#007A3D] text-sm font-semibold">What Drives Us</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#005A2C] mb-6">Our Core Values</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">The fundamental principles that guide everything we do and shape our institutional culture</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="group text-center p-8 bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
              <div className="w-24 h-24 bg-gradient-to-br from-[#007A3D] to-[#005A2C] rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-speed-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#005A2C] mb-4">Efficiency</h3>
              <p className="text-gray-600 leading-relaxed">Achieving our educational objectives with optimal use of resources.</p>
            </div>

            <div className="group text-center p-8 bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
              <div className="w-24 h-24 bg-gradient-to-br from-[#C6A44C] to-[#B8954A] rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-hand-heart-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#005A2C] mb-4">Faith</h3>
              <p className="text-gray-600 leading-relaxed">Trusting in God, especially in times of uncertainty.</p>
            </div>

            <div className="group text-center p-8 bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
              <div className="w-24 h-24 bg-gradient-to-br from-[#007A3D] to-[#005A2C] rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-team-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#005A2C] mb-4">Inclusion</h3>
              <p className="text-gray-600 leading-relaxed">Fostering a tolerant, socially accepting environment that empowers and comprehensively involves the parental community.</p>
            </div>

            <div className="group text-center p-8 bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
              <div className="w-24 h-24 bg-gradient-to-br from-[#C6A44C] to-[#B8954A] rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-lightbulb-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#005A2C] mb-4">Creativity</h3>
              <p className="text-gray-600 leading-relaxed">Encouraging innovative and open-minded approaches to viewing and solving problems.</p>
            </div>

            <div className="group text-center p-8 bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
              <div className="w-24 h-24 bg-gradient-to-br from-[#007A3D] to-[#005A2C] rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-book-open-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-[#005A2C] mb-4">Knowledge</h3>
              <p className="text-gray-600 leading-relaxed">Sharing justified true belief and reasoned opinion.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Principal's Message */}
      <section className="py-20 bg-gradient-to-br from-[#007A3D]/8 via-[#C6A44C]/8 to-[#007A3D]/8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="relative flex items-center justify-center">
              <div className="absolute inset-0 bg-gradient-to-br from-[#007A3D]/30 to-[#C6A44C]/30 rounded-3xl transform -rotate-3"></div>
              <img 
                   src={principalImg}
                   alt="Mr. S. Badza - Principal"
                   className="relative z-10 w-full h-80 sm:h-96 lg:h-[30rem] object-cover object-top rounded-3xl shadow-2xl"
                   decoding="async"
              />
            </div>
            <div className="space-y-8">
              <div>
                <div className="inline-flex items-center px-4 py-2 bg-[#007A3D]/10 rounded-full mb-6">
                  <span className="text-[#007A3D] text-sm font-semibold">Leadership</span>
                </div>
                <h2 className="text-4xl md:text-5xl font-bold text-[#005A2C] mb-6">Message from the Principal</h2>
              </div>
              <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 space-y-6">
                <p className="text-xl text-gray-600 italic leading-relaxed">
                  "Welcome to Elite College, where we believe that education is not just about acquiring knowledge, but about transforming lives and shaping futures for our high school students."
                </p>
                <p className="text-gray-600 leading-relaxed">
                  At Elite College, we are committed to providing an exceptional high school educational experience that goes beyond traditional learning. Our dedicated faculty, state-of-the-art facilities, and innovative programs create an environment where students can excel in their ZIMSEC O-level and A-level studies while developing critical thinking skills and preparing for meaningful careers.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  We believe in nurturing not just academic excellence in our high school curriculum, but also character, leadership, and social responsibility. Our candidates leave not only with their ZIMSEC qualifications, but with the confidence and skills to make a positive impact in their communities and pursue higher education successfully.
                </p>
                <div className="border-t pt-6 space-y-2">
                  <p className="font-bold text-[#005A2C] text-lg">Mr. S. Badza</p>
                  <p className="text-[#C6A44C] font-semibold">Principal</p>
                  <p className="text-sm text-gray-500">Elite College High School</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Educational Approach */}
      <section className="py-20 bg-gradient-to-br from-[#C6A44C]/5 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center px-4 py-2 bg-[#007A3D]/10 rounded-full mb-6">
              <span className="text-[#007A3D] text-sm font-semibold">Our Methodology</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#005A2C] mb-6">Our Educational Approach</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">Holistic education that prepares students for life's challenges and opportunities</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="group text-center p-6 bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
              <div className="w-20 h-20 bg-gradient-to-br from-[#007A3D] to-[#005A2C] rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-brain-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-bold text-[#005A2C] mb-3">Critical Thinking</h3>
              <p className="text-gray-600 text-sm leading-relaxed">Developing analytical skills and independent thought processes</p>
            </div>

            <div className="group text-center p-6 bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
              <div className="w-20 h-20 bg-gradient-to-br from-[#C6A44C] to-[#B8954A] rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-palette-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-bold text-[#005A2C] mb-3">Creativity</h3>
              <p className="text-gray-600 text-sm leading-relaxed">Fostering innovation and artistic expression in all disciplines</p>
            </div>

            <div className="group text-center p-6 bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
              <div className="w-20 h-20 bg-gradient-to-br from-[#007A3D] to-[#005A2C] rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-shield-user-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-bold text-[#005A2C] mb-3">Character Building</h3>
              <p className="text-gray-600 text-sm leading-relaxed">Instilling values of integrity, empathy, and social responsibility</p>
            </div>

            <div className="group text-center p-6 bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
              <div className="w-20 h-20 bg-gradient-to-br from-[#C6A44C] to-[#B8954A] rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-rocket-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-bold text-[#005A2C] mb-3">Future Ready</h3>
              <p className="text-gray-600 text-sm leading-relaxed">Preparing students for emerging careers and global challenges</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-gradient-to-br from-[#005A2C] via-[#007A3D] to-[#005A2C] relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 left-0 w-full h-full bg-[url('data:image/svg+xml,%3Csvg%20width%3D%22100%22%20height%3D%22100%22%20viewBox%3D%220%200%20100%20100%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cpath%20d%3D%22M11%2018c3.866%200%207-3.134%207-7s-3.134-7-7-7-7%203.134-7%207%203.134%207%207%207zm48%2025c3.866%200%207-3.134%207-7s-3.134-7-7-7-7%203.134-7%207%203.134%207%207zm-43-7c1.657%200%203-1.343%203-3s-1.343-3-3-3-3%201.343-3%203%201.343%203%203%203zm63%2031c1.657%200%203-1.343%203-3s-1.343-3-3-3-3%201.343-3%203%201.343%203%203%203zM34%2090c1.657%200%203-1.343%203-3s-1.343-3-3-3-3%201.343-3%203%201.343%203%203%203zm56-76c1.657%200%203-1.343%203-3s-1.343-3-3-3-3%201.343-3%203%201.343%203%203zM12%2086c2.21%200%204-1.79%204-4s-1.79-4-4-4-4%201.79-4%204%201.79%204%204%204zm28-65c2.21%200%204-1.79%204-4s-1.79-4-4-4-4%201.79-4%204%201.79%204%204%204zm23-11c2.76%200%205-2.24%205-5s-2.24-5-5-5-5%202.24-5%205%202.24%205%205%205zm-6%2060c2.21%200%204-1.79%204-4s-1.79-4-4-4-4%201.79-4%204%201.79%204%204%204zm29%2022c2.76%200%205-2.24%205-5s-2.24-5-5-5-5%202.24-5%205%202.24%205%205%205zM32%2063c2.76%200%205-2.24%205-5s-2.24-5-5-5-5%202.24-5%205%202.24%205%205%205zm57-13c2.76%200%205-2.24%205-5s-2.24-5-5-5-5%202.24-5%205%202.24%205%205%205zm-9-21c1.105%200%202-.895%202-2s-.895-2-2-2-2%20.895-2%202%20.895%202%202%202zm60%2091c1.105%200%202-.895%202-2s-.895-2-2-2-2%20.895-2%202%20.895%202%202%202zm35%2041c1.105%200%202-.895%202-2s-.895-2-2-2-2%20.895-2%202%20.895%202%202%202zm12%2060c1.105%200%202-.895%202-2s-.895-2-2-2-2%20.895-2%202%20.895%202%202%202zM40%20100c2%200%204-2%204-4s-2-4-4-4-4%202-4%204%202%204%204%204Z%22%20fill%3D%22%23ffffff%22%20fill-opacity%3D%220.2%22%20fill-rule%3D%22evenodd%22/%3E%3C/svg%3E')]"></div>
        </div>
        <div className="relative z-10 max-w-6xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-12 border border-white/20">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">Join the Elite College Family</h2>
            <p className="text-xl text-white/90 mb-10 max-w-3xl mx-auto leading-relaxed">
              Discover how we can help you achieve your educational goals and unlock your potential for a brighter future
            </p>
            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <Link to="/admissions" className="group relative overflow-hidden bg-[#C6A44C] hover:bg-[#B8954A] text-white px-10 py-5 rounded-xl font-bold text-lg transition-all duration-300 whitespace-nowrap cursor-pointer shadow-2xl hover:shadow-3xl transform hover:-translate-y-1">
                <span className="relative z-10 flex items-center justify-center">
                  Apply Now
                  <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
                </span>
              </Link>
              <Link to="/contact" className="group border-2 border-white/50 hover:border-white text-white hover:bg-white hover:text-[#005A2C] px-10 py-5 rounded-xl font-bold text-lg transition-all duration-300 whitespace-nowrap cursor-pointer backdrop-blur-sm">
                <span className="flex items-center justify-center">
                  Schedule a Visit
                  <i className="ri-calendar-line ml-2"></i>
                </span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#005A2C] text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
            <div className="md:col-span-2">
              <div className="flex items-center mb-6">
                <img 
                  src="https://static.readdy.ai/image/e999ec2dea4e4b618de520757ef9db5d/995999b745e34f0ed4248820e32af9bb.jpeg" 
                  alt="Elite College Logo" 
                  className="h-12 w-12 object-cover rounded-full" />
                <h3 className="text-2xl font-bold ml-3" style={{fontFamily: '"Pacifico", serif'}}>Elite College</h3>
              </div>
              <p className="text-gray-300 mb-6 text-lg leading-relaxed max-w-md">
                Empowering tomorrow's leaders through excellence in education and holistic development since 2019.
              </p>
              <div className="flex space-x-4">
                <button className="w-12 h-12 bg-[#C6A44C] hover:bg-white hover:text-[#005A2C] rounded-full flex items-center justify-center transition-all duration-300 cursor-pointer group">
                  <i className="ri-facebook-fill text-xl group-hover:scale-110 transition-transform"></i>
                </button>
                <button className="w-12 h-12 bg-[#C6A44C] hover:bg-white hover:text-[#005A2C] rounded-full flex items-center justify-center transition-all duration-200 cursor-pointer group">
                  <i className="ri-twitter-fill text-xl group-hover:scale-110 transition-transform"></i>
                </button>
                <button className="w-12 h-12 bg-[#C6A44C] hover:bg-white hover:text-[#005A2C] rounded-full flex items-center justify-center transition-all duration-200 cursor-pointer group">
                  <i className="ri-instagram-line text-xl group-hover:scale-110 transition-transform"></i>
                </button>
                <button className="w-12 h-12 bg-[#C6A44C] hover:bg-white hover:text-[#005A2C] rounded-full flex items-center justify-center transition-all duration-200 cursor-pointer group">
                  <i className="ri-linkedin-fill text-xl group-hover:scale-110 transition-transform"></i>
                </button>
                <a href="https://wa.me/263774872973" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-[#C6A44C] hover:bg-white hover:text-[#005A2C] rounded-full flex items-center justify-center transition-all duration-200 cursor-pointer group">
                  <i className="ri-whatsapp-line text-xl group-hover:scale-110 transition-transform"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-xl font-bold mb-6 text-[#C6A44C]">Contact Info</h4>
              <ul className="space-y-4 text-gray-300">
                <li className="flex items-start">
                  <i className="ri-map-pin-line mr-3 text-[#C6A44C] mt-1 text-lg"></i>
                  <span className="text-lg">535 Mataga</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-phone-line mr-3 text-[#C6A44C] text-lg"></i>
                  <span className="text-lg">+263 774 872 973</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-mail-line mr-3 text-[#C6A44C] text-lg"></i>
                  <span className="text-lg">info@elitecollege.co.zw</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-[#007A3D] pt-8 text-center text-gray-300">
            <p className="text-lg">&copy; 2026 Elite College. All rights reserved.</p>
            <p className="mt-2">
              Powered by <a href="https://onhightech.co.zw" target="_blank" rel="noopener noreferrer" className="text-[#C6A44C] hover:text-white underline cursor-pointer transition-colors">Onhightech Solutions</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
